import {
    AdditionalSellUnit,
    MenuAddon,
    MenuIngredient,
    MenuIngredientsGroup,
    MenuItem,
    MenuItemCombination,
    MenuModifier
} from "../@types/stores/menu";
import {OrderLine, OrderLineIngredients} from "../@types/stores/order";
import menuStore from "../stores/menu";
import lodash from "lodash";
import {isMenuItem, uniqArray} from "./ApiHelper";

export const getAdditionalSellUnitForOrderLine = (line: OrderLine): AdditionalSellUnit | null => {
    // const orderLine = line as OrderLine;
    // if (!orderLine.sellUnitId && !orderLine.sellFactor) return null;
    //
    // const article = menuStore.getArticleOrComboById(orderLine.articleId || orderLine.menuItem.id);
    // if (!article) return null;
    //
    // let articleAdditionalSellUnits = (article as MenuArticle).additionalSellUnits;
    // if (!articleAdditionalSellUnits) return null;
    //
    // articleAdditionalSellUnits = uniqArray(articleAdditionalSellUnits, "name");
    // return articleAdditionalSellUnits.find(x => x.sellUnitId === orderLine.sellUnitId && x.sellFactor === orderLine.sellFactor) || null;


    if (line.menuId && line.subMenuId) {
        const category = menuStore.menu?.find(x => x.id === line.menuId);
        if (category) {
            const subCategory = category?.submenu?.find(x => x.id === line.subMenuId);
            if (subCategory) {
                let item: MenuItem | undefined = undefined;
                if (typeof line.combinationId === "undefined") { // article
                    item = subCategory.articles?.find(x => {
                        if (isMenuItem(x)) {
                            x = x as MenuItem;
                            return x.number === line.number;
                        }
                        return false;
                    }) as MenuItem | undefined;
                }
                else { // combination
                    const combination = subCategory.articles?.find(x => x.id === line.combinationId) as MenuItemCombination | undefined;
                    if (combination) {
                        combination.combination.every(step => {
                            const article = step.articles.find(x => x.article.number === line.number);
                            if (article) {
                                item = article.article;
                                return false;
                            }
                            return true;
                        });
                    }
                }

                if (item) {
                    let articleAdditionalSellUnits = item.additionalSellUnits;
                    if (!articleAdditionalSellUnits) return null;

                    articleAdditionalSellUnits = uniqArray(articleAdditionalSellUnits, "name");
                    return articleAdditionalSellUnits.find(x => x.sellUnitId === line.sellUnitId && x.sellFactor === line.sellFactor) || null;
                }
            }
        }
    }

    return null;
}

export const getModifiersFromOrderLine = (line: OrderLine): MenuModifier[] => {
    const modifiers: MenuModifier[] = [];
    if (line.modifiers?.length) {
        if (line.menuId && line.subMenuId) {
            const category = menuStore.menu?.find(x => x.id === line.menuId);
            if (category) {
                const subCategory = category?.submenu?.find(x => x.id === line.subMenuId);
                if (subCategory) {
                    let item: MenuItem | undefined = undefined;
                    if (typeof line.combinationId === "undefined") { // article
                        item = subCategory.articles?.find(x => {
                            if (isMenuItem(x)) {
                                x = x as MenuItem;
                                return x.number === line.number;
                            }
                            return false;
                        }) as MenuItem | undefined;
                    }
                    else { // combination
                        const combination = subCategory.articles?.find(x => x.id === line.combinationId) as MenuItemCombination | undefined;
                        if (combination) {
                            combination.combination.every(step => {
                                const article = step.articles.find(x => x.article.number === line.number);
                                if (article) {
                                    item = article.article;
                                    return false;
                                }
                                return true;
                            });
                        }
                    }

                    if (item?.modifierGroups) {
                        for (const lineMg of line.modifiers) {
                            const mg = item.modifierGroups.find(x => x.id === lineMg.groupId);
                            if (mg) {
                                for (const lineM of lineMg.items) {
                                    const modifier = mg.items.find(x => x.id === lineM);
                                    if (modifier) {
                                        modifiers.push(modifier);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else if (line.recommendationGroupId) {
            const recommendationGroup = menuStore.recommendations?.find(x => x.id === line.recommendationGroupId);
            if (recommendationGroup) {
                const item = recommendationGroup.articles.find(x => x.number === line.number);
                if (item?.modifierGroups) {
                    for (const lineMg of line.modifiers) {
                        const mg = item.modifierGroups.find(x => x.id === lineMg.groupId);
                        if (mg) {
                            for (const lineM of lineMg.items) {
                                const modifier = mg.items.find(x => x.id === lineM);
                                if (modifier) {
                                    modifiers.push(modifier);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return modifiers;
}

export const getAddonsFromOrderLine = (line: OrderLine): MenuAddon[] => {
    const addons: MenuAddon[] = [];
    if (line.addons?.length) {
        if (line.menuId && line.subMenuId) {
            const category = menuStore.menu?.find(x => x.id === line.menuId);
            if (category) {
                const subCategory = category?.submenu?.find(x => x.id === line.subMenuId);
                if (subCategory) {
                    let item: MenuItem | undefined = undefined;
                    if (typeof line.combinationId === "undefined") { // article
                        item = subCategory.articles?.find(x => {
                            if (isMenuItem(x)) {
                                x = x as MenuItem;
                                return x.number === line.number;
                            }
                            return false;
                        }) as MenuItem | undefined;
                    }
                    else { // combination
                        const combination = subCategory.articles?.find(x => x.id === line.combinationId) as MenuItemCombination | undefined;
                        if (combination) {
                            combination.combination.every(step => {
                                const article = step.articles.find(x => x.article.number === line.number);
                                if (article) {
                                    item = article.article;
                                    return false;
                                }
                                return true;
                            });
                        }
                    }

                    if (item?.addonGroups) {
                        for (const lineAg of line.addons) {
                            const ag = item.addonGroups.find(x => x.id === lineAg.groupId);
                            if (ag) {
                                for (const lineA of lineAg.items) {
                                    const addon = ag.items.find(x => x.id === lineA.id);
                                    if (addon) {
                                        addons.push(addon);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else if (line.recommendationGroupId) {
            const recommendationGroup = menuStore.recommendations?.find(x => x.id === line.recommendationGroupId);
            if (recommendationGroup) {
                const item = recommendationGroup.articles.find(x => x.number === line.number);
                if (item?.addonGroups) {
                    for (const lineAg of line.addons) {
                        const ag = item.addonGroups.find(x => x.id === lineAg.groupId);
                        if (ag) {
                            for (const lineA of lineAg.items) {
                                const addon = ag.items.find(x => x.id === lineA.id);
                                if (addon) {
                                    addons.push(addon);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return addons;
}

export const getIngredientsFromOrderLine = (line: OrderLine): MenuIngredient[] => {
    const ingredients: MenuIngredient[] = [];
    if (line.ingredients?.length) {
        if (line.menuId && line.subMenuId) {
            const category = menuStore.menu?.find(x => x.id === line.menuId);
            if (category) {
                const subCategory = category?.submenu?.find(x => x.id === line.subMenuId);
                if (subCategory) {
                    let item: MenuItem | undefined = undefined;
                    if (typeof line.combinationId === "undefined") { // article
                        item = subCategory.articles?.find(x => {
                            if (isMenuItem(x)) {
                                x = x as MenuItem;
                                return x.number === line.number;
                            }
                            return false;
                        }) as MenuItem | undefined;
                    }
                    else { // combination
                        const combination = subCategory.articles?.find(x => x.id === line.combinationId) as MenuItemCombination | undefined;
                        if (combination) {
                            combination.combination.every(step => {
                                const article = step.articles.find(x => x.article.number === line.number);
                                if (article) {
                                    item = article.article;
                                    return false;
                                }
                                return true;
                            });
                        }
                    }

                    if (item?.ingredientGroups) {
                        for (const lineIg of line.ingredients) {
                            const ig = item.ingredientGroups.find(x => x.id === lineIg.groupId);
                            if (ig) {
                                for (const lineI of lineIg.items.filter(x => x.quantity > 0)) {
                                    const ingredient = ig.items.find(x => x.id === lineI.id);
                                    if (ingredient) {
                                        ingredients.push(ingredient);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else if (line.recommendationGroupId) {
            const recommendationGroup = menuStore.recommendations?.find(x => x.id === line.recommendationGroupId);
            if (recommendationGroup) {
                const item = recommendationGroup.articles.find(x => x.number === line.number);
                if (item?.ingredientGroups) {
                    for (const lineIg of line.ingredients) {
                        for (const lineI of lineIg.items.filter(x => x.quantity > 0)) {
                            const ig = item.ingredientGroups.find(x => x.id === lineIg.groupId);
                            if (ig) {
                                const ingredient = ig.items.find(x => x.id === lineI.id);
                                if (ingredient) {
                                    ingredients.push(ingredient);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return ingredients;
}

export const roundPrice = (price: number): number => {
    return parseFloat((Math.round(price * 100) / 100).toFixed(2));
}

export const getIngredientsForOrderLine = (ingredients: OrderLineIngredients[], ingredientGroups: MenuIngredientsGroup[] | undefined): OrderLineIngredients[] => {
    const _ingredients = lodash.cloneDeep(ingredients);

    if (ingredients.length) {
        // Substract defaultSelected if unselected
        ingredientGroups?.filter(ig => ig.items.filter(i => !!i.default).forEach(i => {
            const _ig = _ingredients.find(_ig => _ig.groupId === ig.id);
            if (_ig) {
                if (!_ig.items.some(_i => _i.id === i.id)) {
                    const quantity = -1 * i.quantity;
                    _ig.items.push({
                        id: i.id,
                        number: i.number,
                        price: i.unitPrice,
                        quantity,
                        sellUnit: i.sellUnit,
                        default: i.default || false
                    });
                }
            }
            else {
                const quantity = -1 * i.quantity;
                _ingredients.push({
                    groupId: ig.id,
                    items: [{
                        id: i.id,
                        number: i.number,
                        price: i.unitPrice,
                        quantity,
                        sellUnit: i.sellUnit,
                        default: i.default || false
                    }]
                });
            }
        }));
    }
    return _ingredients;
}

export const updateAppIfNeeded = (): void => {
    const shouldUpdate = localStorage.getItem("shouldUpdateApp");

    if (shouldUpdate === "true") {
        localStorage.removeItem("shouldUpdateApp");
        window.location.reload();
    }
}

export const cutScannerData = (text: string) => {
    // This logic comes from BO

    return text
    .replaceAll("_", "")
    .replaceAll("?", "")
    .replaceAll("ö", "").replaceAll("Ö", "")
    .replaceAll("ø", "").replaceAll("Ø", "")
    .replaceAll("æ", "").replaceAll("Æ", "");
}
